const testimonialsData = [
  {
    id: 1,
    text: "Being part of Techten Planet Ghana has opened doors we never thought possible. We're not just learning about technology — we’re applying it to real problems in our community.",
    author: "Kwaku Quartey Ansah Ofei, SASEK LABS",
    image: ""
  },
  {
    id: 2,
    text: "This program has given us the tools to create solutions that can change the lives of farmers.",
    author: "Ezra Asiedu, Co-Founder, AgroTech",
    image: ""
  }
];

export default testimonialsData;
